import { createToaster } from '@chakra-ui/react'

/**
 * Toast queue. Kept apart from the `<Toaster />` renderer so feature code can
 * raise notifications without importing a component.
 */
export const toaster = createToaster({
  placement: 'bottom-end',
  pauseOnPageIdle: true,
  duration: 5000,
})

export const notifySuccess = (title, description) =>
  toaster.create({ type: 'success', title, description, closable: true })

export const notifyError = (title, description) =>
  toaster.create({ type: 'error', title, description, closable: true })
